import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { getValidatedRedirectFromQuery, safeNavigate } from '../utils/redirectValidator';
import { getRoleHomePath } from '../utils/adminPermissions';
import { setSession } from '../utils/authSession';
import { apiPost } from '../api/client';

function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [successMessage, setSuccessMessage] = useState(location.state?.message || '');

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location.state?.message) {
      setSuccessMessage(location.state.message);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.pathname, location.state, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await apiPost('/api/auth/login', {
        username,
        password
      });

      // Store both access + refresh tokens for automatic refresh flow.
      setSession({
        accessToken: response.accessToken || response.token,
        user: response.user
      });
      
      // Initialize activity tracking
      const { resetActivityTracking } = await import('../utils/activityTracker');
      resetActivityTracking();

      const roleHome = getRoleHomePath(response.user?.role);
      // Get validated redirect URL from query params, default to role home
      const redirectUrl = getValidatedRedirectFromQuery(searchParams, roleHome);
      safeNavigate(navigate, redirectUrl, roleHome);
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-5">
            <div className="card shadow">
              <div className="card-body p-5">
                <div className="text-center mb-4">
                  <img src="/img/tghlogo.png" alt="TGH Logo" height="60" className="mb-3" />
                  <h2 className="card-title mb-2">Admin Login</h2>
                  <h5 className="text-muted" style={{ color: 'var(--tgh-blue)' }}>
                    Tema General Hospital
                  </h5>
                </div>
              
              {successMessage && (
                <div className="alert alert-success" role="alert">
                  {successMessage}
                </div>
              )}

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="username" className="form-label">
                    Username or Email
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    autoFocus
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading ? 'Logging in...' : 'Login'}
                </button>
              </form>

              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
